import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import NProgress from 'nprogress';
import store from '@/store';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/premium',
    name: 'Premium',
    component: () => import('../views/Premium.vue'),
    beforeEnter: (to, from) => {
      // console.log(to.fullPath);
      // console.log(from.fullPath);

      if (to.name === 'Premium' && from.name === 'Purchase') {
        // console.log('ye chese');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
  },
  {
    path: '/residential',
    name: 'Residential',
    component: () => import('../views/Residential.vue'),
    beforeEnter: (to, from) => {
      // console.log(to.fullPath);
      // console.log(from.fullPath);

      if (to.name === 'Residential' && from.name === 'Purchase') {
        // console.log('ye chese');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
  },
  {
    path: '/dedicated',
    name: 'Dedicated',
    component: () => import('../views/Dedicated.vue'),
    beforeEnter: (to, from) => {
      // console.log(to.fullPath);
      // console.log(from.fullPath);

      if (to.name === 'Dedicated' && from.name === 'Purchase') {
        // console.log('ye chese');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
  },
  {
    path: '/free-proxy-list',
    name: 'Free',
    component: () => import('../views/Free.vue'),
  },
  {
    path: '/web-proxy',
    name: 'Web',
    component: () => import('../views/Web.vue'),
  },
  {
    path: '/online-proxy-checker',
    name: 'Checker',
    component: () => import('../views/Checker.vue'),
    beforeEnter: (to, from) => {
      // console.log(to.fullPath);
      // console.log(from.fullPath);

      if (to.fullPath !== 'online-proxy-checker' && from.fullPath !== '/') {
        // console.log('ye chese');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
  },
  {
    path: '/proxy-filter',
    name: 'Filter',
    component: () => import('../views/Filter.vue'),
  },
  {
    path: '/help-center',
    name: 'Help',
    component: () => import('../views/Help.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/share/:id',
    name: 'Share',
    component: () => import('../views/Share.vue'),
  },
  {
    path: '/cookie-policy',
    name: 'Cookie Policy',
    component: () => import('../pages/cookie-policy.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../pages/privacy-policy.vue'),
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import('../pages/disclaimer.vue'),
  },
  {
    path: '/web-proxy-policies',
    name: 'Web Proxy Policies',
    component: () => import('../pages/web-proxy-policies.vue'),
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms and Conditions',
    component: () => import('../pages/terms-conditions.vue'),
  },
  {
    path: '/purchase',
    name: 'Purchase',
    component: () => import('../views/Purchase.vue'),
    beforeEnter: (to) => {
      // console.log(to.fullPath);
      // console.log(from.fullPath);

      if (to.name === 'Purchase') {
        // console.log('ye chese');
        const showMenu = () => store.commit('SET_MENU');
        showMenu();
      }
    },
  },

  {
    path: '/proxy-types',
    name: 'Types',
    component: () => import('../views/Types.vue'),
  },
  {
    path: '/proxy-types/buy-socks5-proxy',
    name: 'Buy Socks5 Proxy',
    component: () => import('../components/types/BuySocks5.vue'),
  },
  {
    path: '/proxy-types/buy-socks4-proxy',
    name: 'Buy Socks4 Proxy',
    component: () => import('../components/types/BuySocks4.vue'),
  },
  {
    path: '/proxy-types/buy-socks-proxy',
    name: 'Buy Socks Proxy',
    component: () => import('../components/types/BuySocks4.vue'),
  },
  {
    path: '/proxy-types/buy-http-proxy',
    name: 'Buy Http Proxy',
    component: () => import('../components/types/BuyHttp.vue'),
  },
  {
    path: '/proxy-types/buy-https-proxy',
    name: 'Buy Https Proxy',
    component: () => import('../components/types/BuyHttps.vue'),
  },

  {
    path: '/blog',
    name: 'Blog',

    component: () => import('@/blog/views/Blog.vue'),
  },
  {
    path: '/blog/posts/:slug',
    name: 'Post',
    component: () => import('@/blog/views/Post.vue'),
  },
  {
    path: '/blog/categories/:category',
    name: 'Category',
    component: () => import('@/blog/views/Category.vue'),
  },

  {
    path: '/:pathMatch(.*)',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },

  // eslint-disable-next-line consistent-return
  /* scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
  }, */
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  // console.log('start');
  // NProgress.set(0.1);

  next();
});

router.afterEach(() => {
  setTimeout(() => NProgress.done(), 1000);

  // console.log('ending loading');
});

export default router;
